import { Layout } from 'antd';
import React from 'react';
import { Outlet, useResolvedPath } from 'react-router-dom';
import { MenuComponent } from '../../../../../../shared/menu-component';
import { Header } from 'antd/es/layout/layout';
import { PageHeader } from '@ant-design/pro-layout';

interface SectionLayoutProps {}

export const SectionLayout: React.FC<SectionLayoutProps> = (_props) => {
  const chatRoutePath = useResolvedPath('');
  const applicationRoutePath = useResolvedPath('application');
  const filesRoutePath = useResolvedPath('files');
  const transactionsRoutePath = useResolvedPath('transactions');

  const pageLayouts: any[] = [
    {
      path: chatRoutePath.pathname,
      title: 'Messages',
      icon: <></>,
      id: 'ROOT'
    },
    {
      path: applicationRoutePath.pathname,
      title: 'Application',
      icon: <></>,
      id: 'application',
      parent: 'ROOT'
    },
    {
      path: filesRoutePath.pathname,
      title: 'Files',
      icon: <></>,
      id: 'files',
      parent: 'ROOT'
    },
    {
      path: transactionsRoutePath.pathname,
      title: 'Transactions',
      icon: <></>,
      id: 'transactions',
      parent: 'ROOT'
    }
  ];

  return (
    <Layout>
      <Header style={{ position: 'fixed', padding: '0px', width: '100%', background: 'white', zIndex: '1000' }}>
        <PageHeader title="Identity Verification Case" />
        <MenuComponent pageLayouts={pageLayouts} theme="light" mode="horizontal" />
      </Header>
      <Layout.Content
        style={{
          minHeight: '100%',
          background: 'white',
          paddingTop: '64px'
        }}
      >
        <Outlet />
      </Layout.Content>
    </Layout>
  );
};
